import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="saved-venues"
export default class extends Controller {
  selectVenue(event) {
    const venueItem = event.currentTarget.dataset

    if (this.eventLocationController?.hasAddressFieldTarget) {
      this.eventLocationController.addressFieldTarget.value = venueItem.venueAddress
      this.eventLocationController.addressFieldTarget.dispatchEvent(
        new Event("input", { bubbles: true })
      )
    }

    if (this.eventLocationController?.hasVenueNameFieldTarget) {
      this.eventLocationController.venueNameFieldTarget.value = venueItem.venueName
    }
    if (this.eventLocationController?.hasLatitudeFieldTarget) {
      this.eventLocationController.latitudeFieldTarget.value = venueItem.venueLatitude
    }
    if (this.eventLocationController?.hasLongitudeFieldTarget) {
      this.eventLocationController.longitudeFieldTarget.value = venueItem.venueLongitude
    }

    this.modalController?.closeModal()
  }

  stopPropagation(event) {
    event.stopPropagation()
  }

  get modalController() {
    const modalEl = document.getElementById("savedVenuesModal")
    if (!modalEl) return null

    return this.application.getControllerForElementAndIdentifier(modalEl, "modal")
  }

  get eventLocationController() {
    const locationEl = document.querySelector("[data-controller~='event-location']")
    if (!locationEl) return null

    return this.application.getControllerForElementAndIdentifier(locationEl, "event-location")
  }
}
